"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconContainer = exports.CorporateCol = exports.CountryCol = exports.Col = exports.Row = exports.ColumnTitle = exports.HeadingRow = exports.RegionContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const Typography_1 = __importDefault(require("../../../UI/Typography"));
exports.RegionContainer = (0, styled_components_1.default)(styled_bootstrap_grid_1.Container) `
  margin-top: ${props => props.theme.spacing.xl2}px;
  padding: ${props => props.theme.spacing.m1}px;
  background-color: ${props => props.theme.palette.BW_100};
  position: relative;
  align-self: flex-start;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-top: 0;
    top: 0;
    height: 100dvh;
  }
`;
exports.HeadingRow = (0, styled_components_1.default)(styled_bootstrap_grid_1.Row) `
  margin: 0 0 ${props => props.theme.spacing.m1}px 0;
`;
exports.ColumnTitle = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.LIGHT_BLACK};
  margin-bottom: ${props => props.theme.spacing.s2}px;
`;
exports.Row = (0, styled_components_1.default)(styled_bootstrap_grid_1.Row) `
  margin: 0;
`;
exports.Col = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  padding: 0;
`;
exports.CountryCol = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  background-color: ${props => props.theme.palette.LIGHT_GRAY_20};
  padding: ${props => props.theme.spacing.s5}px ${props => props.theme.spacing.m1}px;
  border-radius: ${props => props.theme.attributes.borderRadius.sm}px;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    padding: ${props => props.theme.spacing.s5}px ${props => props.theme.spacing.s4}px;
  }
`;
exports.CorporateCol = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  padding: ${props => props.theme.spacing.s5}px ${props => props.theme.spacing.m1}px;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    padding: ${props => props.theme.spacing.m4}px ${props => props.theme.spacing.m1}px;
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    padding: ${props => props.theme.spacing.m4}px ${props => props.theme.spacing.s4}px;
  }
`;
exports.IconContainer = styled_components_1.default.button `
  top: ${props => props.theme.spacing.m1}px;
  right: ${props => props.theme.spacing.m1}px;
  position: absolute;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
`;
exports.default = {
    RegionContainer: exports.RegionContainer,
    Col: exports.Col,
    Row: exports.Row,
    CountryCol: exports.CountryCol,
    CorporateCol: exports.CorporateCol,
    IconContainer: exports.IconContainer
};
